// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lang-select[data-v-b2807ba8]{\n  position: relative;\n  top: -4px;\n}\n.lang-text[data-v-b2807ba8]{\n  margin-right: 8px;\n  font-weight: 500;  font-family: 'Inter-Medium';\n  font-size: 12px;\n  color: #7A869E;\n}\n.icon-arrow-down[data-v-b2807ba8]{\n  margin-left: 12px;;\n  font-size: 12px;\n  font-weight: bold;\n}\n.country-icon[data-v-b2807ba8]{\n  font-size: 18px;\n}\n@media screen and (max-width: 761px) {\n.lang-text[data-v-b2807ba8]{\n  display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
